import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Sidenav } from '@resy/ui-kitchen';
import Ribbon from '../Ribbon';
import useActiveNavState from './useActiveNavState';
import getInitialNavState from './accountPageNavState';
import AmexAdsContainer from '../../containers/AmexAdsContainer/AmexAdsContainer';
import { getAdDimension } from '../../../../../ui-kitchen/src/components/AmexAds/helpers';

const AccountPageNav = ({
  $rootScope,
  Analytics,
  active,
  isConcierge,
  isGdaUser,
  isLg,
  isScrolled,
}) => {
  const initialNavState = getInitialNavState(() => $rootScope.$broadcast('MODAL', 'onboarding-lite'));
  const activeNavState = useActiveNavState(initialNavState, active);

  const [showAd, setShowAd] = useState(() => window.innerWidth * 0.25 >= getAdDimension('account_page').width);

  useEffect(() => {
    let timeoutId;
    const handleResize = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        setShowAd(window.innerWidth * 0.25 >= getAdDimension('account_page').width);
      }, 150);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return isLg
    ? (
      <div className="sidenav col-3">
        <Sidenav
          Analytics={Analytics}
          items={activeNavState}
          userIsConcierge={isConcierge}
          userIsGlobalDiningAccess={isGdaUser}
        />
        {showAd && <AmexAdsContainer page="account_page" />}
      </div>
    ) : (
      <span className={`Ribbon__container ${isScrolled ? 'scrolled' : ''}`}>
        <Ribbon
          Analytics={Analytics}
          items={activeNavState}
          isConcierge={isConcierge}
          isGlobalDiningAccess={isGdaUser}
        />
      </span>
    );
};

AccountPageNav.propTypes = {
  $rootScope: PropTypes.shape({
    $broadcast: PropTypes.func.isRequired,
  }).isRequired,
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
  active: PropTypes.string.isRequired,
  isConcierge: PropTypes.bool,
  isGdaUser: PropTypes.bool,
  isLg: PropTypes.bool.isRequired,
  isScrolled: PropTypes.bool,
};

AccountPageNav.defaultProps = {
  isConcierge: false,
  isGdaUser: false,
  isScrolled: false,
};
export default AccountPageNav;
